module.exports = __webpack_public_path__ + "static/media/loading.ec520a94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.svg
// module id = 659
// module chunks = 0